import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import {  FormGroup, Validators, FormBuilder } from '@angular/forms';
import { DatePipe, DecimalPipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesDates, MessagesGeneral, MessagesTitles, MessagesSimuladorAgregarDetalle, MessagesStatus } from '../../../models/messages';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from "@angular/material";
import { HttpErrorResponse } from '@angular/common/http';
import { ProspectosService } from 'app/services/operaciones/prospectos/prospectos.service';
import { EmpresasService } from 'app/services/empresas/empresas.service';
import { RiesgoService } from '../../../services/riesgo/riesgo.service';
import { SecurityService } from '../../../services/security/security.service';
import { Subscription } from 'rxjs';
import Swal from "sweetalert2";
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};
@Component({
  selector: 'app-nuevo-prospectos',
  templateUrl: './nuevo-prospectos.component.html',
  styleUrls: ['./nuevo-prospectos.component.scss'],
  providers: [DatePipe, MessagesTitles, MessagesGeneral, MessagesDates, MessagesSimuladorAgregarDetalle, MessagesStatus, DecimalPipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class NuevoProspectosComponent implements OnInit, OnDestroy {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_Prospectos=environment.LABEL_PROSPECTOS;
  Label_Prospecto=environment.LABEL_PROSPECTO;

  Prospectocreado: any;
  arrDataCorreo: any;
  html: string;
  save: boolean = false;
  datos = { Ruc_Adquirente: "" };
  respuesta: any;
  adqui: boolean = false;
  noadqui: boolean = false;
  user: any;
  loading: boolean = false;
  titulo: string = "Crear nuevo "+this.Label_Prospecto.toLowerCase()+".";
  @Output() cerrarNuevoProspecto: EventEmitter<boolean>;
  @Output() refresh = new EventEmitter<any>();
  monedaElement: string;
  empresa: any;
  empresaProv: any;
  parametros: any;
  correo: any;
  formularioCrearProspecto: FormGroup;
  subLista: Subscription[] = [];
  subCrearProspecto: Subscription = new Subscription();
  subEmpresa: Subscription = new Subscription();
  subParametro: Subscription = new Subscription();

  constructor(
    private ProspectoService: ProspectosService,
    private msgStatus: MessagesStatus,
    private msgTitulos: MessagesTitles,
    private empresasService: EmpresasService,
    private riesgosService: RiesgoService,
    private securityService: SecurityService,
    private formBuilder: FormBuilder) {

    this.respuesta = {
      idProspecto: 0,
      Estado: '',
      Observaciones: ''
    }
    this.cerrarNuevoProspecto = new EventEmitter();
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));

    this.formularioCrearProspecto = this.formBuilder.group({
      idProspectoCab: 0,
      Ruc_Adquirente: ['', [Validators.required, Validators.pattern("[0-9]{11}$")]],
      Razon_Social_Adq: [{ value: '', disabled: true }],
      Ruc_Proveedor: ['', [Validators.required, Validators.pattern("[0-9]{11}$")]],
      Razon_Social_Prov: [{ value: "", disabled: true }],
      Tipo_Documento: '',
      Moneda: '',
      Monto_Comercial: 0.00,
      Observaciones_Comercial: '',
      Estado: 'P',
      Fecha_Registro: '',
      Alta_Usuario_Comercial: this.user.Usuario,
      Correo_Usuario_Comercial: this.user.Email,
      Nombre_Usuario_Comercial: this.user.Nombre
    });
  }

  ngOnInit() {
    this.obtenerCorreo();
  }

  ngOnDestroy() {
    this.subLista.forEach(sub => {
      sub.unsubscribe();
    });
  }

  tipoMoneda(event) {
    this.formularioCrearProspecto.controls['Moneda'].setValue(event);
  }

  CerrarPopUp() {
    if (this.save == false) {
      this.cerrarNuevoProspecto.emit();
    } else if (this.save == true) {
      this.cerrarNuevoProspecto.emit();
      this.refresh.emit();
    }
  }

  CrearProspecto() {
    if (this.formularioCrearProspecto.invalid) {
      Swal.fire({
        title: this.msgTitulos.Error,
        text: "Complete los campos requeridos",
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      })
      return false;
    }

    this.loading = true;
    this.subCrearProspecto = this.ProspectoService.crearProspectoCab(this.formularioCrearProspecto.getRawValue()).subscribe(
      res => {
        this.Prospectocreado = res;
        this.loading = false;
        this.save = true;
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        this.msgStatus.getMessage(err.status);
        Swal.fire({
          title: this.msgTitulos.Error,
          text: this.Label_Prospecto+" no creado. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subCrearProspecto);
  }

  validarNumDocumento(control: any) {
    this.adqui = false;
    if (this.formularioCrearProspecto.controls[`${control}`].valid) {
      this.formularioCrearProspecto.get('Razon_Social_Adq').setValue('');
      let datos = {
        Num_Doc_Identificacion: this.formularioCrearProspecto.controls[`${control}`].value
      }
      this.formularioCrearProspecto.controls[`${control}`].disable();
      this.riesgosService.riesgoRUC(datos).subscribe(res => {
        if (res['message']) {
          this.adqui = true;
          this.formularioCrearProspecto.controls['Razon_Social_Adq'].setValue('NO DEFINIDO');
          this.formularioCrearProspecto.controls[`${control}`].enable();
        } else {
          this.adqui = true;
          this.empresa = res;
          this.formularioCrearProspecto.controls[`${control}`].enable();
          this.cargarCampos();
        }
      });
    }
  }

  validarNumDocumentoProv(control: any) {
    this.noadqui = false;
    if (this.formularioCrearProspecto.controls[`${control}`].valid) {
      this.formularioCrearProspecto.get('Razon_Social_Prov').setValue('');
      let datos = {
        Num_Doc_Identificacion: this.formularioCrearProspecto.controls[`${control}`].value
      }
      this.formularioCrearProspecto.controls[`${control}`].disable();
      this.riesgosService.riesgoRUC(datos).subscribe(res => {
        if (res['message']) {
          this.noadqui = true;
          this.formularioCrearProspecto.controls['Razon_Social_Prov'].setValue('NO DEFINIDO');
          this.formularioCrearProspecto.controls[`${control}`].enable();
        } else {
          this.noadqui = true;
          this.empresaProv = res;
          this.formularioCrearProspecto.controls[`${control}`].enable();
          this.cargarCamposProv();
        }
      });
    }
  }

  cargarCampos() {
    this.formularioCrearProspecto.controls['Razon_Social_Adq'].setValue(this.empresa.RazonSocial);
  }

  limpiarAdq() {
    this.formularioCrearProspecto.get('Ruc_Adquirente').setValue('');
    this.formularioCrearProspecto.get('Razon_Social_Adq').setValue('');
  }

  cargarCamposProv() {
    this.formularioCrearProspecto.controls['Razon_Social_Prov'].setValue(this.empresaProv.RazonSocial);
  }

  limpiarProv() {
    this.formularioCrearProspecto.get('Ruc_Proveedor').setValue('');
    this.formularioCrearProspecto.get('Razon_Social_Prov').setValue('');
  }

  cargarListado(control: any) {
    this.subEmpresa = this.empresasService.obtenerListaAdquirentes(this.formularioCrearProspecto.controls[`${control}`].value).subscribe(
      res => {

        this.empresa = res[0];
        if (this.empresa != null) {
          this.adqui = true;
          this.formularioCrearProspecto.controls['Razon_Social_Adq'].setValue(this.empresa.Razon_Social);
        } else {
          this.noadqui = true;
        }

      },
      (err: HttpErrorResponse) => {

        this.loading = false;
        this.msgStatus.getMessage(err.status);
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Error al cargar el listado de "+this.Label_Adquirentes.toLowerCase()+". " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });

      }
    );

    this.subLista.push(this.subEmpresa);
  }

  obtenerCorreo() {
    this.subParametro = this.securityService.ObtenerParametros(1).subscribe(
      res => {

        this.parametros = res;
        let array = this.parametros.filter(arr => arr.Codigo == 'EMAIL_AREA_RIESGO');
        this.correo = array[0].Valor;

      },
      (err1: HttpErrorResponse) => {

        this.loading = false;
        this.msgStatus.getMessage(err1.status);

        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Error al cargar el listado de "+this.Label_Adquirentes.toLowerCase()+". " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });

      }
    );

    this.subLista.push(this.subParametro);
  }
}

